module.exports = __webpack_public_path__ + "img/couples_04_V.8a98816f.jpg";